/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useState, useEffect} from "react";

import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";


import {Col} from "react-bootstrap";


import FormFieldsGroupComponent from "@Components/UI/Forms/Group";
import FormFieldsGroupHeaderComponent from "@Components/UI/Forms/Group/Header";
import FormFieldsGroupFieldsComponent from "@Components/UI/Forms/Group/Fields";
import FormFieldComponent from "@Components/UI/Forms/Field";
import DefaultFormButton from "@Components/UI/Forms/Buttons/Default";


import {REGISTER_FORM_STEP_TYPE, RegisterFormErrorsInterface} from "@UIPages/NotAuthenticated/Register";


type RegisterFormStep4Props = {
    forwardRef?: React.ForwardedRef<any> | null;
    registerFormStep: REGISTER_FORM_STEP_TYPE, registerFormStepHandler(step: number, final?: boolean): void;
    registerFormErrors: RegisterFormErrorsInterface,
    formUserSMSCode: string; formUserSMSCodeHandler(e: React.ChangeEvent<HTMLInputElement> | string): void;
    formUserSMSCodeValidTime: number; formUserSMSCodeValidTimeHandler(time: number): void;
    formUserSMSCodeNumber?: any;
};


export const RegisterFormStep4Component: React.FC<RegisterFormStep4Props> = ({
    forwardRef = null,
    registerFormStep, registerFormStepHandler, registerFormErrors,
    formUserSMSCode, formUserSMSCodeHandler,
    formUserSMSCodeValidTime, formUserSMSCodeValidTimeHandler, formUserSMSCodeNumber
}): JSX.Element => {


    const REST_API_REQUEST_STATUS= useTypedSelector(
        (state):ReturnType<any> => state.interface
    )?.apiRequestStatus;


    const [leftSmsCodeValidTime, setLeftSmsCodeValidTime] = useState<number>(formUserSMSCodeValidTime || 0);
    const [activeCountDown, setActiveCountDown] = useState<any>(null);

    useEffect(() => {
        if (formUserSMSCodeValidTime === 0) return;
        if (activeCountDown) window.clearTimeout(activeCountDown);
        formUserSMSCodeHandler("");
        setLeftSmsCodeValidTime(formUserSMSCodeValidTime);
        formUserSMSCodeValidTimeHandler(0);
    }, [formUserSMSCodeValidTime]);

    useEffect(() => {
        if (leftSmsCodeValidTime > 0) {
            const interval = setTimeout(() => setLeftSmsCodeValidTime(leftSmsCodeValidTime - 1), 1000);;
            setActiveCountDown(interval);
        }
    }, [leftSmsCodeValidTime]);


    const leftMinutes = Math.floor(leftSmsCodeValidTime / 60) || 0
    const leftSeconds = leftSmsCodeValidTime % 60 || 0;

    const formattedTime = `${(leftMinutes < 10 ? "0" : "" ) + leftMinutes.toString()}:${(leftSeconds < 10 ? "0" : "" ) + leftSeconds.toString()}`;

    console.log(registerFormErrors)
    return (
        <FormFieldsGroupComponent forwardRef={forwardRef} cssClasses={registerFormStep !== 4 ? "disabled" : ""}>

            <FormFieldsGroupHeaderComponent headerText={`Zweryfikuj numer telefonu`} />

            <FormFieldsGroupFieldsComponent>

                <FormFieldComponent
                    lg={{span: 4, offset: 4}}
                    fieldValue={formUserSMSCode}
                    fieldValueHandler={e => formUserSMSCodeHandler(e)}
                    fieldType={"number"} fieldLabel={`Podaj kod weryfikacyjny nr ${formUserSMSCodeNumber}`} fieldControlID={`register-form-user-sms-code`}
                    fieldDisabledStatus={registerFormStep !== 4 || !!REST_API_REQUEST_STATUS || !(leftSmsCodeValidTime > 0)}
                    fieldError={registerFormErrors?.formUserSMSCode}
                    cssClasses={"text-center"}
                    fieldLegend={registerFormStep === 4 ? `Pozostały czas: ${formattedTime}` : null}
                />

            </FormFieldsGroupFieldsComponent>

            <>
            {registerFormStep === 4 &&
            <DefaultFormButton
                buttonText={`Zarejestruj się`}
                clickHandler={() => registerFormStepHandler(5, true)}
                controlId={`register-form-user-step5-submit`}
                disabled={!!REST_API_REQUEST_STATUS || !(leftSmsCodeValidTime > 0)}
                cssClasses={`register-form-user-step-submit`}
            />
            }
            </>

            <>
                {registerFormStep === 4 &&
		        <Col xs={12} lg={{span: 4, offset: 4}} style={{marginTop: 50}}>
			        <DefaultFormButton
				        buttonText={`Wygeneruj ponownie`}
				        clickHandler={() => registerFormStepHandler(4, false)}
				        controlId={`register-form-user-step4-submit`}
				        disabled={!!REST_API_REQUEST_STATUS}
				        cssClasses={`register-form-user-step-submit`}
				        size={"sm"}
			        />
		        </Col>
                }
            </>

        </FormFieldsGroupComponent>
    );

};


export default RegisterFormStep4Component;
